import { ref } from 'vue'

import type { Ref } from 'vue'
import type { TzSelectProps } from '../types/interfaces'

interface TzSelectOptions {
  props: TzSelectProps
  onSelect: (value: string) => void
}

interface TzSelectReturn {
  refValue: Ref<string>
  handleSelect: (value: string) => void
}

export const useTzSelect = ({ props, onSelect }: TzSelectOptions): TzSelectReturn => {
  const refValue = ref<string>(props.value || 'UTC')

  const handleSelect = (value: string): void => {
    if (!value) return
    refValue.value = value
    onSelect(value)
  }

  return {
    refValue,
    handleSelect,
  }
}
